/**
 * Locale-aware currency formatting (§15.6 — never hand-format money).
 *
 * Renders an amount in its ISO-4217 currency via the platform Intl API, so INR
 * shows "₹1,500.00" and USD "$1,500.00" with the right symbol and digit
 * grouping for the viewer's locale. Pure presentation — it never changes a
 * stored amount or currency code.
 */
/**
 * Format `amount` in `currency` (ISO 4217). `locale` defaults to the runtime
 * locale (per §15.1 resolution). Falls back to "CODE 1500.00" for an
 * unknown/invalid currency code rather than throwing in render; "—" for
 * empty/non-numeric input.
 */
export function formatMoney(amount, currency, locale) {
    if (amount == null || amount === '')
        return '—';
    const n = typeof amount === 'string' ? Number(amount) : amount;
    if (Number.isNaN(n))
        return '—';
    const code = (currency || '').toUpperCase();
    try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: code }).format(n);
    }
    catch {
        return `${code} ${n.toFixed(2)}`;
    }
}
